import { atom } from 'recoil'

export const modalThirdPartyState = atom({
  key: 'messageEditModalThirdPartyState',
  default: {
    show: false
  }
})

export const modalSaveAsTemplateState = atom({
  key: 'messageEditModalSaveAsTemplateState',
  default: {
    show: false,
    id: undefined,
    title: '',
    lists: [],
    saveToLists: [],
    selectAll: false
  }
})

export const modalErrorState = atom({
  key: 'messageEditModalErrorState',
  default: {
    show: false
  }
})

export const modalResumeAutoSave = atom({
  key: 'messageEditModalResumeAutoSave',
  default: {
    show: false
  }
})

export const modalConcurrentAccess = atom({
  key: 'messageEditModalConcurrentAccess',
  default: {
    show: false
  }
})

export const modalPreview = atom({
  key: 'messageEditModalPreview',
  default: {
    show: false
  }
})
export const modalSave = atom({
  key: 'messageEditModalSave',
  default: {
    show: false,
    exit: false,
    openQuickSend: false
  }
})

export const modalConfirmEnableNotificationState = atom({
  key: 'messageEditModalConfirmEnableNotificationState',
  default: {
    show: false,
    requiresUpdateWelcomeSeries: undefined,
    messageType: undefined,
    openQuickSend: false,
    exit: false
  }
})

export const modalConfirmExitState = atom({
  key: 'messageEditModalConfirmExitState',
  default: {
    show: false
  }
})

export const modalConfirmLeaveState = atom({
  key: 'messageEditModalConfirmLeaveState',
  default: {
    afterExit: false
  }
})

export const modalOfferLightUpsellState = atom({
  key: 'messageEdit__modalOfferLightUpsell',
  default: {
    show: false
  }
})
